import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSpecificCollectionDetail } from "../redux/actions/collectionActions";
import { resetFilters, fetchFilters } from "../redux/actions/filterActions";

function Collections() {
  const { type } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux state
  const { categoryItem, loading, error } = useSelector(
    (state) => state.collection
  );

  useEffect(() => {
    if (type) {
      dispatch(getSpecificCollectionDetail(type.toLowerCase()));
    }
  }, [dispatch, type]);

  useEffect(() => {
    dispatch(fetchFilters());
    dispatch(resetFilters()); // Reset filters on mount
  }, [dispatch]);

  const title = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "Collection";

  const handleItemClick = (sub_cat_name, sub_cat_id) => {
    // const slug = sub_cat_name.replace(/\s+/g, '_');
    navigate(
      `/products?catId=${categoryItem?.cat_id}&category=${encodeURIComponent(
        categoryItem?.cat_name
      )}&subCatId=${sub_cat_id}&subCategory=${encodeURIComponent(sub_cat_name)}`
    );
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-center mb-10 text-gray-800 tracking-wide">
        {title} Collection
      </h1>

      {loading && (
        <p className="text-center text-gray-600 text-lg">Loading...</p>
      )}

      {error && <p className="text-center text-red-500 text-lg">{error}</p>}

      {!loading &&
        !error &&
        (!categoryItem || categoryItem?.subcategories === 0) && (
          <p className="text-center text-gray-500 text-lg">
            No items found for this category.
          </p>
        )}

      {!loading &&
        !error &&
        categoryItem?.subcategories &&
        categoryItem?.subcategories?.length > 0 && (
          <div className="flex flex-wrap justify-center gap-8">
            {categoryItem?.subcategories?.map((item, index) => (
              <div
                key={index}
                onClick={() =>
                  handleItemClick(item.sub_cat_name, item.sub_cat_id)
                }
                className="w-[220px] bg-white rounded-2xl shadow-xl hover:shadow-pink-300 transition duration-300 ease-in-out transform hover:-translate-y-2 cursor-pointer flex flex-col items-center overflow-hidden"
              >
                <div className="w-full h-60 overflow-hidden">
                  <img
                    loading="lazy"
                    src={item.sub_cat_img}
                    alt={item.sub_cat_name}
                    className="w-full h-60 transition duration-300 ease-in-out hover:scale-110"
                  />
                </div>
                <div className="py-4 flex justify-center px-2 bg-pink-50 w-full">
                  <p className="text-lg font-semibold text-pink-700 tracking-wide">
                    {item.sub_cat_name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}

export default Collections;
